import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WatchlistTabLabelProps {
  count: number;
}

// AC-8/§3 Q5 — the pill exists only above zero; a magenta "0" would read as an alert for the one
// result that explicitly is not one, and the empty state already says so in words.
export const WatchlistTabLabel = ({ count }: WatchlistTabLabelProps) => {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {t('application.tab.watchlist')}
      {count > 0 && (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '22px',
            height: '22px',
            padding: '0 6px',
            borderRadius: '11px',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {count}
        </Box>
      )}
    </Box>
  );
};
